import $ from 'jquery';

export default class Alerts {
	constructor(options) {
		this.boxClassName = options.boxClassName;
		this.closeButtonClass = options.closeButtonClass;
		this.init();
	}

	init() {
		Array.prototype.slice.call(document.getElementsByClassName(this.boxClassName)).map(this.addListeners.bind(this));
	}

	addListeners(box) {
		$(box).find("."+this.closeButtonClass).on('click', (event) => this.onCloseButtonClick(event, box) );
	}

	onCloseButtonClick(event, box) {
		$(box).slideUp();
	}
	
}